(function () {
  var DATA_SCHEMA_VERSION = 1;
  var dataCache = null;
  var expiryTimer = null;
  var renderQueued = false;

  function getBanner() {
    return document.querySelector('[data-popular-choice-banner]');
  }

  function getBannerText(banner) {
    return banner && banner.querySelector('[data-popular-choice-text]');
  }

  function hideBanner(banner) {
    var text = getBannerText(banner);

    if (text) text.textContent = '';
    if (!banner) return;

    banner.hidden = true;
    banner.setAttribute('aria-hidden', 'true');
    banner.style.display = 'none';
  }

  function showBanner(banner, percent) {
    var text = getBannerText(banner);

    if (!text) return;

    text.textContent = String(percent) + '% of people made the same choice';
    banner.hidden = false;
    banner.removeAttribute('aria-hidden');
    banner.style.removeProperty('display');
  }

  function isPlainObject(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
  }

  function isValidPercent(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && value >= 1 && value <= 100;
  }

  function hasFreshSchema(data, now) {
    var generatedAt;
    var expiresAt;

    if (!isPlainObject(data)) return false;
    if (data.schemaVersion !== DATA_SCHEMA_VERSION) return false;
    if (!isPlainObject(data.variants)) return false;

    generatedAt = Date.parse(data.generatedAt);
    expiresAt = Date.parse(data.expiresAt);

    if (!isFinite(generatedAt) || !isFinite(expiresAt)) return false;
    if (expiresAt < generatedAt) return false;
    if (now.getTime() > expiresAt) return false;

    return true;
  }

  function scheduleExpiryCheck(data) {
    var expiresAt = Date.parse(data.expiresAt);
    var delay = expiresAt - Date.now() + 1000;

    if (expiryTimer) {
      window.clearTimeout(expiryTimer);
      expiryTimer = null;
    }

    if (!isFinite(delay) || delay <= 0) return;

    expiryTimer = window.setTimeout(scheduleRender, Math.min(delay, 2147483647));
  }

  function fetchPopularChoiceData(url) {
    if (!url) return Promise.resolve(null);

    if (dataCache && dataCache.url === url) {
      return dataCache.promise;
    }

    dataCache = {
      url: url,
      promise: fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Popular choice data unavailable.');
          return response.json();
        })
        .then(function (data) {
          if (!hasFreshSchema(data, new Date())) return null;
          scheduleExpiryCheck(data);
          return data;
        })
        .catch(function () {
          return null;
        }),
    };

    return dataCache.promise;
  }

  function renderBanner() {
    var banner = getBanner();
    var dataUrl;
    var variantId;

    if (!banner) return;

    hideBanner(banner);

    dataUrl = banner.getAttribute('data-popular-choice-data-url');
    variantId = banner.getAttribute('data-popular-choice-variant-id');

    if (!dataUrl || !variantId) return;

    fetchPopularChoiceData(dataUrl).then(function (data) {
      var percent;

      if (!data || !hasFreshSchema(data, new Date())) return;
      if (!document.documentElement.contains(banner)) return;
      if (banner.getAttribute('data-popular-choice-variant-id') !== variantId) return;

      percent = data.variants[variantId];
      if (!isValidPercent(percent)) return;

      showBanner(banner, percent);
    });
  }

  function scheduleRender() {
    if (renderQueued) return;

    renderQueued = true;

    var run = function () {
      renderQueued = false;
      renderBanner();
    };

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  function bindEvents() {
    document.addEventListener('catchmaster:cart-mode-signal', scheduleRender);
    document.addEventListener('catchmaster:cart-mode-changed', scheduleRender);
  }

  function bootstrap() {
    bindEvents();
    scheduleRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
